export default __webpack_public_path__ + "static/media/330_store04-nl-web.270cafda.png";